import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolState'
})
export class BoolStatePipe implements PipeTransform {
  transform(value: boolean, translations: string[]): string {
    if(value) return translations[0];
    else return translations[1];
  }

}
